import {useEffect, useState} from "react"

export default function useScreenSize() {

    const [width, setWidth] = useState(window.innerWidth)

    const handleWindowSizeChange = () => {
        setWidth(window.innerWidth)
    }

    const matchSize = size => {
        if (size >= 1400) {
            return 'xxl'
        }
        if (size >= 1200) {
            return 'xl'
        }
        if (size >= 992) {
            return 'lg'
        }
        if (size >= 768) {
            return 'md'
        }
        if (size >= 576) {
            return 'sm'
        }
        return 'xs'
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange)
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange)
        }
    }, [])

    return {
        width,
        isMobile: matchSize(width) === 'sm' || matchSize(width) === 'xs',
        isXsMobile: matchSize(width) === 'xs',
        screen: matchSize(width)
    }
}
